// The unified SPA deploys at the root of its origin, so paths never need a prefix.
// `withBase` stays as an identity shim so callsites read uniformly and we can reintroduce a
// prefix later without sweeping the codebase if a deploy ever needs one.

export const BASE = '';

export function withBase(path: string): string {
    return path;
}

/**
 * Build the work detail URL. Routes on the full Work id with a decorative
 * trailing slug (`/work/{id}/{slug}`, E3); when the slug is missing (a freshly
 * minted Work whose denormalizer hasn't run yet) it falls back to the bare
 * `/work/{id}` form. Both hit the same component, and the server resolves off
 * the id either way.
 */
export function workUrl(pkg: { id: string; slug?: string | null }): string {
    if (pkg.slug && pkg.slug.length > 0) {
        return `/work/${encodeURIComponent(pkg.id)}/${encodeURIComponent(pkg.slug)}`;
    }
    return `/work/${encodeURIComponent(pkg.id)}`;
}

export const PATHS = {
    home: '/',
    work: (id: string) => `/work/${encodeURIComponent(id)}`,
};

/**
 * Build the Gposingway Studio install-handoff URL. The scheme is a locked
 * contract (legacy CLAUDE.md invariant 3): `gwpackage://open/?package=<base64>`
 * where the payload is `JSON.stringify({ name, url })` and `url` is the direct
 * fetchable archive Studio downloads. The base64 is UTF-8-safe so non-Latin1
 * preset / creator names never throw `btoa`; the `url` field is always ASCII.
 *
 * Studio registers the `gwpackage://` scheme like `mailto:` or `steam:`. It is
 * in development (no public build yet), so this link opens nothing until Studio
 * ships - always pair it with a direct download (the manual, tool-free path).
 */
export function gwpackageUrl(name: string, url: string): string {
    const payload = JSON.stringify({ name, url });
    const bytes = new TextEncoder().encode(payload);
    let binary = '';
    for (const byte of bytes) binary += String.fromCharCode(byte);
    return `gwpackage://open/?package=${btoa(binary)}`;
}
